import GraphQL from './ConsultaGraphQL';

import url from '../../../../../apiService/ApiUrl.js';

// JavaScript Document
function handleError(err){
	console.log(`Request failed: ${err}`);
}

const deleteEmpresa = (This, empresa) => {
	const options = {
		method: 'post',
		headers: {
			"Content-type": "application/json"
		},
		body: JSON.stringify(GraphQL(empresa)),
		credentials: 'include'
	}

	//llamada de datos con Fetch
	fetch(url, options)
	.then(res => res.json())
	.then( (res) => {

		This.props.dispatch({
			type: 'DELETE_EMPRESA',
			payload: {
				dataEmpresa: empresa
			}
		})

		//console.log(res)
		//return res
	})
	.catch(err => handleError(err));

	//termina fetch
}

export default deleteEmpresa;